import { IBaseResponseModel } from "../../models/common/models.type";
import { ILoginResponse, IGoogleLoginRequest } from "../../models/auth";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { ITranslateRequest } from "../../models/translate";
import { HistoryTranslate } from "../../page/main/AiToolsPage";

const API_AUTH = ApiEndpoints.AUTH;
const baseURL = envConfig.API_ENDPOINT;

const create = async (params: FormData): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API_AUTH.CREATE.url, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  //return res;
};

const pdfCreate = async (
  params: FormData,
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API_AUTH.PdfCreate.url, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  //return res;
};

const createSuccess = async (
  params: HistoryTranslate,
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API_AUTH.CREATESUCCESS.url, params);
  //return res;
};

const deleteFile = (id: string): Promise<IBaseResponseModel<any>> => {
  return api.delete(baseURL, API_AUTH.DELETEFILE.url, {
    params: { id },
  });
};

const getFilePreview = async (
  orderId: string,
): Promise<IBaseResponseModel<HistoryTranslate>> => {
  return api.get(baseURL, API_AUTH.GetFilePreview.url + "?orderId=" + orderId);
  //return res;
};

const TranslateService = {
  create,
  createSuccess,
  deleteFile,
  pdfCreate,
  getFilePreview,
};

export default TranslateService;
